import { Controller } from "@hotwired/stimulus";

const PORTAL_ATTR = "data-turbo-native-workflow-chrome-portaled";

export default class extends Controller {
    static targets = ["buttonHost", "offcanvasHost"];

    connect() {
        if (!document.body.classList.contains("turbo-native")) return;

        this.portalChrome();

        this.boundRefresh = (event) => {
            if (this.isWorkflowNavEvent(event)) this.schedulePortalChrome();
        };

        document.addEventListener("turbo:frame-render", this.boundRefresh);
        document.addEventListener("turbo:frame-load", this.boundRefresh);
        document.addEventListener("turbo:morph", this.boundRefresh);
    }

    disconnect() {
        if (!this.boundRefresh) return;

        document.removeEventListener("turbo:frame-render", this.boundRefresh);
        document.removeEventListener("turbo:frame-load", this.boundRefresh);
        document.removeEventListener("turbo:morph", this.boundRefresh);
    }

    isWorkflowNavEvent(event) {
        const frame = event?.target;
        if (!frame?.id) return false;

        return frame.id.includes("steps_recap_");
    }

    schedulePortalChrome() {
        requestAnimationFrame(() => {
            if (this.element.isConnected) this.portalChrome();
        });
    }

    buttonElement() {
        if (!this.hasButtonHostTarget) return null;

        return this.buttonHostTarget.querySelector(".step-nav-mobile-button");
    }

    offcanvasElement() {
        if (!this.hasOffcanvasHostTarget) return null;

        return this.offcanvasHostTarget.querySelector("#nav");
    }

    cleanupStalePortals() {
        const button = this.buttonElement();
        const offcanvas = this.offcanvasElement();

        document.querySelectorAll(`body > .step-nav-mobile-button[${PORTAL_ATTR}]`).forEach((el) => {
            if (el !== button) el.remove();
        });

        document.querySelectorAll(`body > #nav[${PORTAL_ATTR}]`).forEach((el) => {
            if (el !== offcanvas) el.remove();
        });
    }

    portalChrome() {
        if (!document.body.classList.contains("turbo-native")) return;

        const offcanvas = this.offcanvasElement();
        if (offcanvas?.classList.contains("show")) return;

        this.cleanupStalePortals();

        const button = this.buttonElement();
        if (button && button.parentElement !== document.body) {
            button.setAttribute(PORTAL_ATTR, "true");
            document.body.appendChild(button);
        }

        if (offcanvas && offcanvas.parentElement !== document.body) {
            offcanvas.setAttribute(PORTAL_ATTR, "true");
            document.body.appendChild(offcanvas);
        }
    }
}
